import { call, put, SagaReturnType, takeEvery } from 'redux-saga/effects';
import { schedularAnnouncementActions } from 'src/redux/actions/constant';
import therapistService from 'src/services/apiServices/therapist-scheduling/therapistService';
const {
  UPDATE_ANNOUNCEMENT_REQUEST,
  UPDATE_ANNOUNCEMENT_SUCCESS,
  UPDATE_ANNOUNCEMENT_FAILURE,
  GET_ALL_ANNOUNCEMENTS_REQUEST,
} = schedularAnnouncementActions;

function* updateAnnouncement(action: any): SagaReturnType<any> {
  try {
    const response = yield call(therapistService.updateAnnouncement, action.payload);
    if (response?.status === 200) {
      yield put({ type: UPDATE_ANNOUNCEMENT_SUCCESS, payload: response.data });
      yield put({
        type: GET_ALL_ANNOUNCEMENTS_REQUEST,
        payload: { selectedDate: action.payload.date },
      });
    } else {
      throw response.data;
    }
  } catch (error) {
    yield put({ type: UPDATE_ANNOUNCEMENT_FAILURE, payload: error });
  }
}

function* updateAnnouncementSaga() {
  yield takeEvery(UPDATE_ANNOUNCEMENT_REQUEST, updateAnnouncement);
}

export default updateAnnouncementSaga;
